// extracted by mini-css-extract-plugin
export default {"ratingBar-container":"styles_ratingBar-container__Sh-rw","ratingBar-filter":"styles_ratingBar-filter__KXfqe","ratingBar-label":"styles_ratingBar-label__I2bcd"};